
import axios from '../../helpers/axios';


export const updatedProduct = (id, payload) => {
    return axios.patch(`product/update/${id}`, payload);
};
export const deletedProduct = (id) => axios.delete(`/product/delete/${id}`)
